/**
 * Lang_ES
 */
export class Lang_ES {
    constructor() {
        /**
         * lang content
         * @private
         */
        this._content = {
            'Mammal Watching · Processing · Analysing': 'Observación de mamíferos · Procesamiento · Análisis',
            'A platform to record, process and analyse marine-mammal sightings around the Canary Islands.': 'Una plataforma para registrar, procesar y analizar avistamientos de mamíferos marinos alrededor de las Islas Canarias.',
            'A project of the association:': 'Un proyecto de la asociación:',
            'Open source on': 'Código abierto en',
            'currents, biogeochemistry': 'corrientes, biogeoquímica',
            'chlorophyll-a, salinity, sea-level anomaly': 'clorofila-a, salinidad, anomalía del nivel del mar',
            'solar radiation / UV, meteorology': 'radiación solar / UV, meteorología',
            'weather & marine weather': 'clima y meteorología marina',
            'climate indices (NAO, AMO, …)': 'índices climáticos (NAO, AMO, …)',
            'depth grid & map tiles': 'malla de profundidad y teselas de mapa',
            'depth (fallback)': 'profundidad (reserva)',
            'earthquakes': 'terremotos',
            'live AIS vessel positions': 'posiciones AIS de buques en vivo',
            'fishing effort': 'esfuerzo pesquero',
            'taxonomy / phylogeny': 'taxonomía / filogenia',
            'tree-of-life explorer': 'explorador del árbol de la vida',
            'base map': 'mapa base',
            'relief tiles': 'teselas de relieve',
            'external tour bookings': 'reservas de tours externas',
            'The species silhouettes above (shown on the map and in sighting popovers) are from': 'Las siluetas de especies de arriba (mostradas en el mapa y en los popovers de avistamientos) provienen de',
            '© the respective authors (mostly': '© los respectivos autores (principalmente',
            '), licensed under': '), con licencia',
            ', CC0 and Public Domain. The full per-file list is in': ', CC0 y dominio público. La lista completa por archivo está en',
            'Built with AdminLTE 4, Bootstrap 5, OpenLayers, D3/dc.js and the': 'Construido con AdminLTE 4, Bootstrap 5, OpenLayers, D3/dc.js y la biblioteca de widgets',
            ' widget library.': '.',
            'Pulled external_tour rows remain in the database as a historical record.': 'Las filas external_tour obtenidas permanecen en la base de datos como registro histórico.',
            'Historical sightings keep their reference, but the vehicle disappears from operational pickers.': 'Los avistamientos históricos mantienen su referencia, pero el vehículo desaparece de los selectores operativos.',
            'Historical sightings that reference it keep the link; it disappears from the picker for new sightings. Revive it later from the Edit dialog.': 'Los avistamientos históricos que lo referencian mantienen el enlace; desaparece del selector para nuevos avistamientos. Puedes reactivarlo luego desde el diálogo Editar.',
            'Access roles': 'Roles de acceso',
            'None set': 'Sin asignar',
            'Specie-Name': 'Nombre de especie',
            'Ott-Id': 'Ott-Id',
            'WoRMS aphia-ID': 'WoRMS aphia-ID',
            'Specie-Group': 'Grupo de especie',
            'Specie source': 'Especie origen',
            'Specie destination': 'Especie destino',
            'Specie save success.': 'Especie guardada correctamente.',
            'User save success.': 'Usuario guardado correctamente.',
            'Show all': 'Mostrar todo',
            'Transfer': 'Transferir',
            'Reset': 'Restablecer',
            'Start Editing': 'Iniciar edición',
            'Stop Editing': 'Detener edición',
            'Clear Points': 'Borrar puntos',
            '(no species)': '(sin especie)',
            'Click for details': 'Haz clic para detalles',
            'OSM tiles': 'Teselas OSM',
            'Bathymetry': 'Batimetría',
            'Relief (ES)': 'Relieve (ES)',
            'Weather + waves': 'Clima + olas',
            'Ocean currents': 'Corrientes oceánicas',
            'Oceanography & climate': 'Oceanografía y clima',
            'Seismic': 'Sísmica',
            'Maritime traffic': 'Tráfico marítimo',
            'Taxonomy': 'Taxonomía',
            'Base maps': 'Mapas base',
            'Bottlenose Dolphin': 'Delfín mular',
            'Atlantic Spotted Dolphin': 'Delfín moteado atlántico',
            'Striped Dolphin': 'Delfín listado',
            'Common Dolphin': 'Delfín común',
            'Rough-Toothed Dolphin': 'Delfín de dientes rugosos',
            'Fraser\'s Dolphin': 'Delfín de Fraser',
            'Risso\'s Dolphin': 'Delfín de Risso',
            'Pilot Whale': 'Calderón',
            'False Killer Whale': 'Falsa orca',
            'Orca': 'Orca',
            'Sperm Whale': 'Cachalote',
            'Pygmy Sperm Whale': 'Cachalote pigmeo',
            'Cuvier\'s Beaked Whale': 'Zifio de Cuvier',
            'Blainville\'s Beaked Whale': 'Zifio de Blainville',
            'Gervais\' Beaked Whale': 'Zifio de Gervais',
            'Northern Bottlenose Whale': 'Ballena nariz de botella del norte',
            'Humpback Whale': 'Ballena jorobada',
            'North Atlantic Right Whale': 'Ballena franca del Atlántico Norte',
            'Fin Whale': 'Rorcual común',
            'Sei Whale': 'Rorcual boreal',
            'Blue Whale': 'Ballena azul',
            'Bryde\'s Whale': 'Rorcual de Bryde',
            'Minke Whale': 'Rorcual aliblanco',
            'Sea Turtle': 'Tortuga marina',
            'Chlorophyll-a (mg/m³)': 'Clorofila-a (mg/m³)',
            'Chl-a distribution (mg/m³)': 'Distribución de Chl-a (mg/m³)',
            'SST distribution (°C)': 'Distribución de SST (°C)',
            'Salinity distribution (PSU)': 'Distribución de salinidad (PSU)',
            'Sea level anomaly distribution (cm)': 'Distribución de anomalía del nivel del mar (cm)',
            'Current speed distribution (m/s)': 'Distribución de velocidad de corriente (m/s)',
            'Depth distribution (m)': 'Distribución de profundidad (m)',
            'Air temperature distribution (°C)': 'Distribución de temperatura del aire (°C)',
            'UV index distribution': 'Distribución del índice UV',
            'Wave height distribution (m)': 'Distribución de altura de ola (m)',
            'Wave period distribution (s)': 'Distribución de periodo de ola (s)',
            'Fishing hours distribution (h/day, 25 km)': 'Distribución de horas de pesca (h/día, 25 km)',
            'Chl-a vs Fishing effort': 'Chl-a vs. esfuerzo pesquero',
            'Chl-a — monthly mean': 'Chl-a — media mensual',
            'Top species': 'Especies principales',
            'Top fishing gear types': 'Tipos de arte de pesca principales',
            'Top vessel flags': 'Banderas de buque principales',
            'Load all': 'Cargar todo',
            'sightings under the current filter?': 'avistamientos con el filtro actual?',
            'never': 'nunca',
            'never run': 'nunca ejecutado',
            'no sightings yet': 'aún sin avistamientos',
            'No matching tours — relax a picker.': 'Ningún tour coincide — relaja un filtro.',
            'Alte Daten (manuell erfasst) einblenden': 'Mostrar datos antiguos (registrados a mano)',
            'Unblock IP': 'Desbloquear IP',
            'Unlock login': 'Desbloquear inicio de sesión',
            'Delete Encounter Category': 'Eliminar categoría de encuentro',
            'Soft-delete this encounter category?': '¿Eliminar (soft) esta categoría de encuentro?',
            'Are you sure you want to delete the vehicle?': '¿Seguro que quieres eliminar el vehículo?',
            ' Dependent services will be stopped too. This affects the live backend.': ' También se detendrán los servicios dependientes. Esto afecta al backend en vivo.',
            'Delete external tour source': 'Eliminar fuente de tours externa',
            'Delete this source config?': '¿Eliminar esta configuración de fuente?',
            'Delete Specie': 'Eliminar especie',
            'Are you sure you want to delete the specie?': '¿Seguro que quieres eliminar la especie?',
            'Load all ...': 'Cargar todo ...',
            'Edit': 'Editar',
            'Save': 'Guardar',
            'Brush a range on the chart to enable actions.': 'Selecciona un rango en el gráfico para activar las acciones.',
            'Use this position': 'Usar esta posición',
            'Unlock': 'Desbloquear',
            'Unblock': 'Desbloquear',
            'Stop': 'Detener',
            'Start': 'Iniciar',
            'speed (kt)': 'velocidad (kn)',
            'Show Map': 'Mostrar mapa',
            'Set rights': 'Establecer permisos',
            'search persons / tour-fid …': 'Buscar personas / tour-fid …',
            'search note / recognizable …': 'Buscar nota / reconocible …',
            'Scan this code with the MWPA mobile app to sign in.': 'Escanea este código con la app MWPA para iniciar sesión.',
            'Refresh': 'Actualizar',
            'Previous tour (no candidate)': 'Tour anterior (sin candidato)',
            'points / bucket': 'puntos / intervalo',
            'persons / tour-fid …': 'personas / tour-fid …',
            'Other tour by ID': 'Otro tour por ID',
            'not set': 'no definido',
            'note / recognizable …': 'nota / reconocible …',
            'Next tour (no candidate)': 'Tour siguiente (sin candidato)',
            'Name of user': 'Nombre del usuario',
            'Name of specie': 'Nombre de la especie',
            'Merge': 'Fusionar',
            'Invoke now': 'Ejecutar ahora',
            'Fullname of user': 'Nombre completo del usuario',
            'Fishing vessels': 'Barcos de pesca',
            'Filter rights …': 'Filtrar permisos …',
            'Code expired - click Refresh to generate a new one.': 'Código caducado: haz clic en Actualizar para generar uno nuevo.',
            'Assign tracks': 'Asignar tracks',
            'Assign to tour': 'Asignar al tour',
            'Sighting saved.': 'Avistamiento guardado.',
            'Sighting save failed.': 'Error al guardar el avistamiento.',
            'Sighting delete success.': 'Avistamiento eliminado.',
            'Creating new sightings via this dialog is not supported yet.': 'La creación de nuevos avistamientos mediante este diálogo aún no está disponible.',
            'ID is not set!': '¡El ID no está definido!',
            'Role saved.': 'Rol guardado.',
            'Role save failed.': 'Error al guardar el rol.',
            'Role deleted.': 'Rol eliminado.',
            'Role delete failed.': 'Error al eliminar el rol.',
            'Rights saved.': 'Permisos guardados.',
            'Rights save failed.': 'Error al guardar los permisos.',
            'Encounter saved.': 'Encuentro guardado.',
            'Encounter deleted.': 'Encuentro eliminado.',
            'Group save success.': 'Grupo guardado.',
            'Source saved.': 'Fuente guardada.',
            'Source deleted.': 'Fuente eliminada.',
            'Specie delete success.': 'Especie eliminada.',
            'Specie merge success.': 'Especies fusionadas.',
            'Area save success.': 'Área guardada.',
            'New password is save.': 'Nueva contraseña guardada.',
            'New pin is save.': 'Nuevo PIN guardado.',
            'IP unblocked.': 'IP desbloqueada.',
            'IP was no longer blocked.': 'La IP ya no estaba bloqueada.',
            'Login unlocked.': 'Inicio de sesión desbloqueado.',
            'Lockout was no longer active.': 'El bloqueo ya no estaba activo.',
            'Name is required.': 'El nombre es obligatorio.',
            'Company shortname is required.': 'El nombre corto de empresa es obligatorio.',
            'Please select an organisation.': 'Selecciona una organización.',
            'Add new Group': 'Añadir nuevo grupo',
            'Edit Group': 'Editar grupo',
            'Edit Sighting': 'Editar avistamiento',
            'Delete a sighting': 'Eliminar avistamiento',
            'Details': 'Detalles',
            'Change password': 'Cambiar contraseña',
            'Change mobile app pin': 'Cambiar PIN de la app móvil',
            'Tracking points · time / count / speed': 'Puntos de seguimiento · tiempo / recuento / velocidad',
            'Add Encounter': 'Añadir encuentro',
            'Add Group': 'Añadir grupo',
            'Add role': 'Añadir rol',
            'Add source': 'Añadir fuente',
            'Add tour': 'Añadir tour',
            'About': 'Acerca de',
            'access': 'Acceso',
            'active': 'activo',
            'Activity': 'Actividad',
            'Add Encounter Category': 'Añadir categoría de encuentro',
            'Add external tour source': 'Añadir fuente de tours externa',
            'Add new tour': 'Añadir nuevo tour',
            'Add User': 'Añadir usuario',
            'admin': 'admin',
            'Admin': 'Admin',
            'App Quick Connect': 'App Quick Connect',
            'Are you sure you want to delete the sighting? Please describe:': '¿Seguro que quieres eliminar el avistamiento? Describe por favor:',
            'Assign orphan tracks': 'Asignar tracks huérfanos',
            'Avatar': 'Avatar',
            'Base URL': 'URL base',
            'Behaviour co-occurrence': 'Co-ocurrencia de comportamientos',
            'Blacklist': 'Lista negra',
            'Blacklist (blocked IPs)': 'Lista negra (IPs bloqueadas)',
            'Browser': 'Navegador',
            'Capacity': 'Capacidad',
            'Coastal current (m/s, ±)': 'Corriente costera (m/s, ±)',
            'Company shortname': 'Nombre corto de empresa',
            'Count': 'Recuento',
            'Created by': 'Creado por',
            'Credits & licenses': 'Créditos y licencias',
            'Data sources': 'Fuentes de datos',
            'Date / Start': 'Fecha / Inicio',
            'Date / Time': 'Fecha / Hora',
            'Deg / Min (N/S/E/W)': 'Grad / Min (N/S/E/O)',
            'Deleted': 'Eliminado',
            'Dependencies': 'Dependencias',
            'Description': 'Descripción',
            'Device': 'Dispositivo',
            'Devices': 'Dispositivos',
            'disabled': 'desactivado',
            'Distance<br>(Miles)': 'Distancia<br>(millas)',
            'Distance from pick': 'Distancia al punto elegido',
            'Distance to nearest coast (nm)': 'Distancia a la costa más cercana (mn)',
            'Distinct tours the sightings came from — the cluster unit. Sightings on one tour are not independent.': 'Tours distintos de los que provienen los avistamientos — la unidad de agrupación. Los avistamientos de un mismo tour no son independientes.',
            'Edit Encounter Category': 'Editar categoría de encuentro',
            'Edit external tour source': 'Editar fuente de tours externa',
            'Edit Species': 'Editar especie',
            'Edit User': 'Editar usuario',
            'EMail': 'Correo electrónico',
            'Enabled': 'Activado',
            'Encounter Categories': 'Categorías de encuentro',
            'Encounters': 'Encuentros',
            'Environmental response (effort-corrected)': 'Respuesta ambiental (corregida por esfuerzo)',
            'E. without GPS': 'E. sin GPS',
            'External tour sources': 'Fuentes de tours externas',
            'External Tour Sources': 'Fuentes de tours externas',
            'Filter': 'Filtro',
            'First blocked': 'Primer bloqueo',
            'First / Last seen': 'Primera / Última vez visto',
            'First seen': 'Primera vez visto',
            'from Device': 'desde dispositivo',
            'Fullname': 'Nombre completo',
            'Gi* hotspots': 'Puntos calientes Gi*',
            'Groups': 'Grupos',
            'Hostname': 'Nombre de host',
            'Hotspots & utilization distribution': 'Puntos calientes y distribución de uso',
            'Importance': 'Importancia',
            'IP': 'IP',
            'Is Admin': 'Es admin',
            'Is Disabled': 'Está desactivado',
            'Item': 'Elemento',
            'Item ids (comma-separated; empty = all)': 'IDs de elementos (separados por comas; vacío = todos)',
            'Last blocked': 'Último bloqueo',
            'Last login': 'Último inicio de sesión',
            'Last path': 'Última ruta',
            'Last pull': 'Última sincronización',
            'Last seen': 'Última vez visto',
            'Latitude': 'Latitud',
            'Lat / Lon (decimal)': 'Lat / Lon (decimal)',
            'Live AIS Map': 'Mapa AIS en vivo',
            'Login lockouts': 'Bloqueos de inicio de sesión',
            'Longitude': 'Longitud',
            'Main group': 'Grupo principal',
            'Meeting point': 'Punto de encuentro',
            'Merge Species': 'Fusionar especies',
            'name': 'nombre',
            'New password': 'Nueva contraseña',
            'New pin': 'Nuevo PIN',
            'No co-occurring behaviours': 'Sin comportamientos co-ocurrentes',
            'No effort data for a seasonal estimate': 'Sin datos de esfuerzo para una estimación estacional',
            'No effort data for a trend': 'Sin datos de esfuerzo para una tendencia',
            'No tracking points': 'Sin puntos de seguimiento',
            'Ocean & Fishing': 'Océano y pesca',
            'Organisation': 'Organización',
            'Orphan Tracks': 'Tracks huérfanos',
            'OS': 'SO',
            'Password': 'Contraseña',
            'Password repeat': 'Repetir contraseña',
            'Persons on boat': 'Personas a bordo',
            'Pick freely (off-route)': 'Elegir libremente (fuera de ruta)',
            'Pick position': 'Elegir posición',
            'Pin': 'PIN',
            'Pin repeat': 'Repetir PIN',
            'Please pick a boat — AROC requires one file per boat.': 'Elige un barco — AROC requiere un archivo por barco.',
            'Points': 'Puntos',
            'Position begin': 'Posición inicio',
            'Position end': 'Posición fin',
            'Prices': 'Precios',
            'Provider': 'Proveedor',
            'Provider / Company / Items': 'Proveedor / Empresa / Elementos',
            'Red = 50% core / 95% home-range (UD) or significant Gi* hot spot (z≥1.96); blue = Gi* cold spot. Kernel density over all positioned sightings.': 'Rojo = núcleo 50% / área de campeo 95% (UD) o punto caliente Gi* significativo (z≥1,96); azul = punto frío Gi*. Densidad kernel sobre todos los avistamientos posicionados.',
            'Region current (m/s)': 'Corriente regional (m/s)',
            'Repeat password': 'Repetir contraseña',
            'Repeat pin': 'Repetir PIN',
            'Role': 'Rol',
            'Roles': 'Roles',
            'Scheduler': 'Programador',
            'Search': 'Buscar',
            'search name / description …': 'Buscar nombre / descripción …',
            'search name / group / ott-id / WoRMS …': 'Buscar nombre / grupo / OTT-ID / WoRMS …',
            'search username / fullname / email …': 'Buscar usuario / nombre / correo …',
            'Seasonality (effort-corrected)': 'Estacionalidad (corregida por esfuerzo)',
            '— Select a boat —': '— Elegir barco —',
            'Services': 'Servicios',
            'Share of each metric’s variance that is between-tour rather than within-tour. High values mean sightings cluster by tour — treat them as non-independent (use tour as a random effect in any model).': 'Proporción de la varianza de cada métrica que es entre tours en lugar de dentro de un tour. Valores altos indican que los avistamientos se agrupan por tour — trátalos como no independientes (usa el tour como efecto aleatorio en cualquier modelo).',
            'Sighting duration from': 'Duración del avistamiento desde',
            'Species silhouettes': 'Siluetas de especies',
            'Target species’ share of ALL sightings per environment bin (background = where surveying happened), with a Wilson 95% band. Unlike the raw histograms above, this is not inflated by how much was surveyed at each value.': 'Proporción de la especie objetivo sobre TODOS los avistamientos por intervalo ambiental (fondo = dónde se muestreó), con banda de Wilson al 95%. A diferencia de los histogramas anteriores, esto no se infla por cuánto se muestreó en cada valor.',
            'The project': 'El proyecto',
            'Too few positioned sightings for a spatial estimate (need at least 10).': 'Muy pocos avistamientos posicionados para una estimación espacial (se necesitan al menos 10).',
            'Too few tours to estimate (need at least two tours per metric).': 'Muy pocos tours para estimar (se necesitan al menos dos tours por métrica).',
            'too few years for a fit': 'muy pocos años para un ajuste',
            'Tour clustering (ICC)': 'Agrupación por tour (ICC)',
            'Tour-Fid': 'Tour-Fid',
            'Tour ID': 'ID de tour',
            'Tour list': 'Lista de tours',
            'Tours External': 'Tours externos',
            'Tour start': 'Inicio del tour',
            'Tracking points': 'Puntos de seguimiento',
            'track pts': 'ptos',
            'Transfer tracking points': 'Transferir puntos de seguimiento',
            'Type': 'Tipo',
            'Unique tours': 'Tours únicos',
            'until': 'hasta',
            'User Groups': 'Grupos de usuarios',
            'Username': 'Nombre de usuario',
            'User / Organization': 'Usuario / Organización',
            'Users': 'Usuario',
            'Utilization (50/95%)': 'Uso (50/95%)',
            'Vehicle / Driver': 'Vehículo / Conductor',
            'Which behaviours were recorded together in the same sighting (ribbon width = shared sightings). Co-occurrence, not a behavioural sequence.': 'Qué comportamientos se registraron juntos en el mismo avistamiento (ancho de cinta = avistamientos compartidos). Co-ocurrencia, no una secuencia de comportamientos.',
            'Wind speed (m/s)': 'Velocidad del viento (m/s)',
            'Without tracks': 'Sin tracks',
            'Yearly SPUE trend': 'Tendencia anual de SPUE',
            'title': 'MWPA',
            'login_title': '<b>MWPA</b>',
            'Sighting': 'Avistamiento',
            'Tours': 'Salidas',
            'Species': 'Especies',
            'Add sighting': 'Añadir avistamiento',
            'Add new sighting': 'Añadir nuevo avistamiento',
            'Date': 'Fecha',
            'Vehicle': 'Embarcación',
            'Driver': 'Patrón',
            'Group-Size': 'Tamaño del grupo',
            'Time begin': 'Hora de inicio',
            'Time end': 'Hora de fin',
            'Duration': 'Duración',
            'Location': 'Ubicación',
            'Encounter': 'Encuentro',
            'Other species': 'Otras especies',
            'Add Specie': 'Añadir especie',
            'List': 'Lista',
            'Map': 'Mapa',
            'Analytics': 'Análisis',
            'Year comparison': 'Comparación anual',
            'Export': 'Exportar',
            'Excel Export': 'Exportación Excel',
            'Excel Report': 'Informe Excel',
            'Data Page': 'Hoja de datos',
            'Columns': 'Columnas',
            'Standard columns': 'Columnas estándar',
            'Optional columns': 'Columnas opcionales',
            'Select all': 'Seleccionar todo',
            'Deselect all': 'Deseleccionar todo',
            'Coordinate format': 'Formato de coordenadas',
            'Download Excel': 'Descargar Excel',
            'Sighting metadata': 'Metadatos del avistamiento',
            'Sea depth': 'Profundidad',
            'Weather (day mean)': 'Tiempo (media diaria)',
            'Weather (at sighting hour)': 'Tiempo (hora del avistamiento)',
            'Id': 'ID',
            'Start of trip': 'Inicio de salida',
            'End of trip': 'Fin de salida',
            'Boat': 'Embarcación',
            'Skipper': 'Patrón',
            'Observer': 'Observador',
            'Wind/Seastate (Beaufort)': 'Viento/Estado del mar (Beaufort)',
            'Number of animals': 'Número de animales',
            'Duration from': 'Duración desde',
            'Duration until': 'Duración hasta',
            'Estimation without GPS': 'Estimación sin GPS',
            'Distance to nearst coast (nm)': 'Distancia a la costa (mn)',
            'Juveniles': 'Juveniles',
            'Calves': 'Crías',
            'Newborns': 'Recién nacidos',
            'Behaviour': 'Comportamiento',
            'Group structure': 'Estructura del grupo',
            'Subgroups': 'Subgrupos',
            'Reaction': 'Reacción',
            'Frequent behaviours of individuals': 'Comportamientos frecuentes individuales',
            'Photos taken': 'Fotos realizadas',
            'Recognizable animals': 'Animales reconocibles',
            'Other': 'Otros',
            'Other boats present': 'Otras embarcaciones presentes',
            'Note': 'Nota',
            'UUID': 'UUID',
            'Sighting type': 'Tipo de avistamiento',
            'Organization': 'Organización',
            'Created at': 'Creado el',
            'Updated at': 'Actualizado el',
            'Tour FID': 'Tour FID',
            'Sea depth (m)': 'Profundidad (m)',
            'Depth provider': 'Proveedor de profundidad',
            'Sea-surface temperature (Day mean, °C)': 'Temperatura del agua (Media diaria, °C)',
            'Air temperature (Day mean, °C)': 'Temperatura del aire (Media diaria, °C)',
            'UV index (Day max)': 'Índice UV (Máx. del día)',
            'Wave height (Day mean, m)': 'Altura de ola (Media diaria, m)',
            'Wave period (Day mean, s)': 'Periodo de ola (Media diaria, s)',
            'Wave direction (Day mean, °)': 'Dirección de ola (Media diaria, °)',
            'Sea-surface temperature (At hour, °C)': 'Temperatura del agua (A la hora, °C)',
            'Air temperature (At hour, °C)': 'Temperatura del aire (A la hora, °C)',
            'UV index (At hour)': 'Índice UV (A la hora)',
            'Wave height (At hour, m)': 'Altura de ola (A la hora, m)',
            'Wave period (At hour, s)': 'Periodo de ola (A la hora, s)',
            'Wave direction (At hour, °)': 'Dirección de ola (A la hora, °)',
            'Decimal degrees (e.g. 28.123, -16.456)': 'Grados decimales (p. ej. 28.123, -16.456)',
            'DMS — Degrees Minutes Seconds (e.g. 28° 07′ 24″ N)': 'DMS — Grados Minutos Segundos (p. ej. 28° 07′ 24″ N)',
            'DM — Degrees Decimal Minutes (e.g. 28° 07.41′ N)': 'DM — Grados Minutos Decimales (p. ej. 28° 07.41′ N)',
            'All formats (extra columns per position)': 'Todos los formatos (columnas adicionales por posición)',
            'Species (Top 10)': 'Especies (Top 10)',
            'Sightings per month': 'Avistamientos por mes',
            'Weekday × hour-of-day': 'Día de la semana × hora del día',
            'Group size distribution': 'Distribución del tamaño de grupo',
            'Cumulative sightings': 'Avistamientos acumulados',
            'Calendar': 'Calendario',
            'Cumulative trend': 'Tendencia acumulada',
            'No sightings under current filter.': 'Sin avistamientos con el filtro actual.',
            'No sightings available for year-on-year comparison.': 'No hay avistamientos para la comparación anual.',
            'No dated sightings available.': 'No hay avistamientos con fecha disponibles.',
            'sightings analysed.': 'avistamientos analizados.',
            'sightings across': 'avistamientos en',
            'year': 'año',
            'years': 'años',
            'Day': 'Día',
            'Name': 'Nombre',
            'Country': 'País',
            'Lon': 'Longitud',
            'Lat': 'Latitud',
            'Province': 'Provincia',
            'Island': 'Isla',
            'Port': 'Puerto',
            'E-Mail': 'Correo electrónico',
            'Website': 'Web',
            'AROC region': 'AROC Región',
            'AROC number': 'AROC Número',
            'AROC year': 'AROC Año',
            'AROC reference': 'AROC Referencia',
            'Authorized boats': 'Nº barcos autorizados',
            'Close': 'Cerrar',
            'Save changes': 'Guardar cambios',
            'AROC office report': 'Informe AROC',
            'Year': 'Año',
            'All years': 'Todos los años',
            'External receiver': 'Receptor externo',
            'No receivers configured': 'Ningún receptor configurado',
            'Download report': 'Descargar informe',
            'Generating…': 'Generando…',
            'Download failed': 'Descarga fallida',
            'Loading…': 'Cargando…',
            'Semester': 'Semestre',
            'Full year': 'Año completo',
            '1st semester (Jan–Jun)': '1er semestre (Ene–Jun)',
            '2nd semester (Jul–Dec)': '2do semestre (Jul–Dic)',
            'All boats': 'Todas las embarcaciones',
            'Add new Organization': 'Añadir nueva organización',
            'Edit Organization': 'Editar organización',
            'Add Organization': 'Añadir organización',
            'Generate PDF': 'Generar PDF',
            'Combines map, analytics and year comparison on a printable sheet. Uses the browser\'s print dialog — pick "Save as PDF" there.': 'Combina mapa, análisis y comparación anual en una hoja imprimible. Usa el diálogo de impresión del navegador — seleccione "Guardar como PDF" allí.',
            'All organizations': 'Todas las organizaciones',
            'Vehicles': 'Embarcaciones',
            'Vehicle Name': 'Nombre de la embarcación',
            'Name of vehicle': 'Nombre de la embarcación',
            'Add Vehicle': 'Añadir embarcación',
            'Edit Vehicle': 'Editar embarcación',
            'Delete Vehicle': 'Eliminar embarcación',
            'Are you sure you want to delete the vehicle? Historical sightings keep their reference, but the vehicle disappears from operational pickers.': '¿Seguro que desea eliminar la embarcación? Los avistamientos históricos conservan la referencia, pero la embarcación desaparece de los selectores operativos.',
            'Vehicle save success.': 'Embarcación guardada correctamente.',
            'Vehicle delete success.': 'Embarcación eliminada correctamente.',
            'Please select an organization.': 'Seleccione una organización.',
            'Please enter a vehicle name.': 'Introduzca un nombre de embarcación.',
            'In use (shown in operational pickers)': 'En uso (visible en los selectores)',
            'Deleted (hidden from admin list)': 'Eliminada (oculta en la lista de administración)',
            'in use': 'en uso',
            'not in use': 'fuera de uso',
            'deleted': 'eliminada',
            'Status': 'Estado',
            'Action': 'Acción',
            'Delete': 'Eliminar',
            'search name / organization …': 'buscar nombre / organización …',
            'Rebuild movements': 'Recalcular movimientos',
            'Rebuild every sighting\'s movement track now? This may take a while.': '¿Recalcular ahora los trayectos de movimiento de todos los avistamientos? Puede llevar un rato.',
            'Rebuilding movements…': 'Recalculando movimientos…',
            'Rebuild done': 'Recálculo finalizado',
            'Rebuild failed': 'Recálculo fallido',
            'Movement tracks': 'Trayectos de movimiento',
            'Movement settings': 'Ajustes de movimiento',
            'Lead buffer (minutes before sighting start)': 'Margen anterior (minutos antes del inicio del avistamiento)',
            'Trail buffer (minutes after sighting end)': 'Margen posterior (minutos después del fin del avistamiento)',
            'Apply lead/trail around recorded duration (off = strict)': 'Aplicar margen anterior/posterior a la duración registrada (off = estricto)',
            'Outlier speed threshold (km/h, segments above are bad)': 'Umbral de velocidad anómala (km/h, los tramos por encima se descartan)',
            'Local timezone for legacy HH:MM (IANA, e.g. Atlantic/Canary)': 'Zona horaria local para HH:MM antiguo (IANA, p. ej. Atlantic/Canary)',
            'Settings saved': 'Ajustes guardados',
            'Load failed': 'Carga fallida',
            'Save failed': 'Guardado fallido',
            // Species Profile — títulos y KPI
            'Profile': 'Perfil',
            'Species Profile': 'Perfil de especie',
            'Period': 'Periodo',
            'Sightings': 'Avistamientos',
            'Animals (sum)': 'Animales (suma)',
            'Median group': 'Mediana tamaño de grupo',
            'p95 group': 'p95 tamaño de grupo',
            'Sightings per hour-of-day': 'Avistamientos por hora del día',
            'Composition (sightings reporting …)': 'Composición (avistamientos con …)',
            'Environment preference': 'Preferencia ambiental',
            'Distance to coast (m)': 'Distancia a la costa (m)',
            'SST (°C)': 'Temperatura superficial (°C)',
            'Chl-a (mg/m³)': 'Clorofila-a (mg/m³)',
            'Behaviour mix': 'Mezcla de comportamientos',
            'Reaction to boat': 'Reacción al barco',
            'Movement signature (derived from SightingMovement)': 'Firma de movimiento (derivada de SightingMovement)',
            'Spatial distribution': 'Distribución espacial',
            'Dominant heading rose': 'Rosa de rumbos dominantes',
            'Sightings w/ movement': 'Avistamientos con movimiento',
            'Median avg speed': 'Mediana velocidad media',
            'Median max speed': 'Mediana velocidad máx.',
            'Median total distance': 'Mediana distancia total',
            'No data': 'Sin datos',
            'No positions': 'Sin posiciones',
            'No heading data': 'Sin datos de rumbo',
            'Show description': 'Mostrar descripción',
            // Species Profile — descripciones
            'desc.monthly': 'Número de avistamientos de esta especie por mes natural, sumado a lo largo de todos los años en el rango seleccionado. Útil para detectar presencia estacional.',
            'desc.hourly': 'Número de avistamientos por hora del día (según la hora de inicio de la salida). Muestra los picos de actividad de observación. Nota: refleja el esfuerzo de observación, no necesariamente la actividad real de los animales.',
            'desc.group_size': 'Distribución de tamaños de grupo registrados (species_count por avistamiento). Se lee como «con qué frecuencia se encontraron X animales juntos». Los últimos buckets recogen los valores atípicos.',
            'desc.group_ratios': 'Proporción de avistamientos que reportaron presencia de juveniles, crías o neonatos. Valores altos sugieren uso como hábitat de cría o crianza.',
            'desc.env': 'Condiciones ambientales en las posiciones de avistamiento. Caracteriza la envoltura de hábitat preferida (profundidad, distancia a la costa, temperatura del agua, concentración de clorofila).',
            'desc.behaviour': 'Estados de comportamiento registrados durante el avistamiento (de BehaviouralStates). Un avistamiento puede aportar varias etiquetas; se muestran los 8 primeros, el resto bajo «other».',
            'desc.reaction': 'Reacción de los animales hacia la embarcación de observación (de EncounterCategories). Útil para evaluar impacto y habituación.',
            'desc.movement': 'Firma de movimiento derivada de la tabla SightingMovement — sólo los avistamientos con segmento de track contribuyen. Las velocidades son medianas en nudos; la rosa muestra la distribución de 8 sectores del rumbo dominante por avistamiento.',
            'desc.heatmap': 'Posiciones agregadas de todos los avistamientos en el filtro. Cada punto usa location_begin; la intensidad del mapa de calor marca los puntos calientes de encuentros repetidos. Se muestran hasta ~2000 puntos.',
            // Species Profile Phase 3
            'Sightings per tour-hour (SPUE)': 'Avistamientos por hora de salida (SPUE)',
            'Sightings per year': 'Avistamientos por año',
            'Co-occurring species (same tour)': 'Especies co-ocurrentes (misma salida)',
            'Pressure indicators': 'Indicadores de presión',
            'Extended environment (oceanographic)': 'Entorno extendido (oceanográfico)',
            'Tour hours': 'Horas de salida',
            'tours': 'salidas',
            'Beaufort sea state': 'Estado del mar (Beaufort)',
            'Fishing hours (25 km, day)': 'Horas de pesca (25 km, día)',
            'Salinity (PSU)': 'Salinidad (PSU)',
            'SLA (cm)': 'SLA (cm)',
            'Current speed (m/s)': 'Velocidad de la corriente (m/s)',
            'Wave height (m)': 'Altura de ola (m)',
            'UV index': 'Índice UV',
            'desc.spue': 'Tasa de encuentro corregida por esfuerzo: número de avistamientos por hora de salida en el mes correspondiente. Barras = avistamientos, línea continua = horas de salida (eje derecho), línea discontinua = SPUE. Hace visibles tendencias que el conteo bruto enmascararía — métrica estándar en cetología.',
            'desc.yearly': 'Avistamientos por año natural — complementario al gráfico mensual, útil para tendencias multianuales. Atención: sin corrección SPUE, las fluctuaciones pueden ser puros efectos de esfuerzo.',
            'desc.cooccurrence': 'Especies más frecuentes vistas en las mismas salidas (mismo tour_fid) que esta especie. Cuenta salidas distintas; se excluye doble conteo por salida. Límite 12 especies.',
            'desc.pressure': 'Indicadores de presión: estado del mar (Beaufort) durante el avistamiento, número de otros barcos presentes (de «other_vehicle»), horas de pesca comercial en un radio de 25 km el día del avistamiento (GFW).',
            'desc.env_extra': 'Variables oceanográficas adicionales de SightingExtended: salinidad (PSU), anomalía del nivel del mar (cm), velocidad de la corriente (m/s), altura de ola (m), índice UV. Medias diarias.',
            // Cross-species analytics page (Phase 4)
            'Cross-species analytics': 'Análisis entre especies',
            'Species comparison': 'Comparación de especies',
            'Year × SPUE': 'Año × SPUE',
            'SST × group size': 'Temp. superficial × tamaño de grupo',
            'Chlorophyll-a × group size': 'Clorofila-a × tamaño de grupo',
            'Tour effort × sightings': 'Esfuerzo × avistamientos',
            'Pooled fit': 'Regresión agrupada',
            '(all species)': '(todas las especies)',
            'slope': 'pendiente',
            '< min_n (no fit)': '< min_n (sin ajuste)',
            'desc.regression.page': 'Cuatro diagramas de dispersión sobre todas las especies, cada uno con una línea de regresión por especie (color) y una regresión agrupada sobre todos los puntos (discontinua negra). Si el signo o la pendiente de la línea agrupada se separa de las líneas de color, estamos ante la paradoja de Simpson — la vista agrupada contradice las tendencias por especie. Las especies con < 10 puntos siguen apareciendo como puntos pero sin su propia línea.',
            'desc.reg.year_spue': 'Tasa de encuentro corregida por esfuerzo por año y especie. X = año natural, Y = avistamientos ÷ horas de salida en ese año. Revela tendencias multianuales que el esfuerzo desigual ocultaría.',
            'desc.reg.sst_groupsize': 'Temperatura superficial del agua frente al tamaño de grupo. Un avistamiento = un punto. Caso clásico de Simpson: agregado puede parecer débil mientras que por especie es fuerte — diferentes especies habitan diferentes rangos térmicos.',
            'desc.reg.chl_groupsize': 'Clorofila-a (proxy de productividad) frente al tamaño de grupo. Mayor Chl-a indica aguas productivas — comprueba si los grupos grandes usan zonas más productivas.',
            'desc.reg.effort': 'Horas de salida mensuales frente a avistamientos de la misma especie ese mes. Una curva de saturación (pendiente sub-lineal) indicaría que más esfuerzo no rinde proporcionalmente más avistamientos; una relación lineal sugiere muestreo limitado por esfuerzo.',
            // Orphan tracks
            'Orphan track preview': 'Vista previa de pending-tracks',
            'Delete bucket': 'Eliminar bucket',
            'No decodable points in this bucket': 'Sin puntos decodificables en este bucket',
            // Earthquake admin page (Phase 5)
            'Earthquakes': 'Terremotos',
            'Events': 'Eventos',
            'Period from': 'Periodo desde',
            'Period to': 'Periodo hasta',
            'Min magnitude': 'Magnitud mín.',
            'Apply': 'Aplicar',
            'Reload': 'Recargar',
            'When': 'Cuándo',
            'Mag': 'Mag.',
            'Depth (km)': 'Profundidad (km)',
            'Place': 'Lugar',
            'Source': 'Fuente',
            'Recorrelate all': 'Recorrelacionar todo',
            'Recorrelate done': 'Recorrelación completada',
            'Recorrelate confirm': '¿Recorrelacionar todos los avistamientos con todos los terremotos almacenados? En bases grandes puede tardar — ver registro.',
            'Impact window': '± Ventana',
            'Impact window hint': 'Qué avistamientos están «afectados» — ventanas temporales con sentido biológico por terremoto. Cualquier valor distinto de «ninguno» carga el impacto sobre todos los terremotos listados.',
            'Hide sightings': 'No mostrar avistamientos',
            '±3 days': '±3 días',
            '±7 days': '±7 días',
            '±14 days': '±14 días',
            'window.hint.off': 'Mostrar solo la lista de terremotos, sin renderizar correlaciones de avistamientos',
            'window.hint.24h': 'Reacción aguda al estrés (varamientos, efectos de ondas P/S)',
            'window.hint.3d': 'Cambios conductuales a corto plazo',
            'window.hint.7d': 'Desplazamiento / cambio de migración a medio plazo',
            'window.hint.14d': 'Amplio, capta efectos retardados (ruidoso)',
            'Impact analysis': 'Análisis de impacto',
            'Impact load failed': 'Fallo al cargar el impacto',
            'By species': 'Por especie',
            'By behaviour': 'Por conducta',
            'By encounter category': 'Por categoría de encuentro',
            'Hours offset (signed)': 'Desfase horario (con signo)',
            'Window': 'Ventana',
            'days': 'días',
            'events': 'eventos',
            'Affected sightings': 'Avistamientos afectados',
            'Correlations': 'Correlaciones',
            // Species Profile — seismic exposure
            'Seismic exposure': 'Exposición sísmica',
            'Sightings w/ event': 'Avistamientos con evento',
            'Sighting × event pairs': 'Pares avistamiento × evento',
            'Max magnitude': 'Magnitud máx.',
            'Median distance': 'Distancia mediana',
            'Magnitude': 'Magnitud',
            'Distance to epicenter (km)': 'Distancia al epicentro (km)',
            'Offset (h, +event before sighting)': 'Desfase (h, +evento antes del avistamiento)',
            'desc.seismic': 'Correlaciones de la tabla `sighting_seismic`: cada avistamiento de esta especie se ha emparejado con terremotos a ≤ 200 km y ±14 días. KPI a la izquierda: número de avistamientos con al menos un evento cercano, total de pares avistamiento × evento, magnitud máxima, mediana de distancia. Los histogramas muestran la distribución de magnitud, distancia y desfase temporal — desfases positivos = evento previo al avistamiento. Una asimetría positiva del desfase es interesante para detectar respuestas conductuales.'
        };
    }
    /**
     * getLangCode
     */
    getLangCode() {
        return 'es';
    }
    /**
     * getLangTitle
     */
    getLangTitle() {
        return 'Español';
    }
    /**
     * getCountryCode
     */
    getCountryCode() {
        return 'es';
    }
    /**
     * l
     * @param acontent
     */
    l(acontent) {
        if (this._content[acontent]) {
            return this._content[acontent];
        }
        return null;
    }
    /**
     * getClassName
     */
    getClassName() {
        return 'Lang_ES';
    }
}
